export default "__VITE_ASSET__BdlzzsNC__"